export const maintenanceScreenWeb = 'core-maintenance-screen-login-web'
export const trustThisDeviceWeb = 'core-trust-this-device-web'
export const signInWithAppleWeb = 'core-sign-in-with-apple-web'
export const signInWithAppleOAuthWeb = 'core-sign-in-with-apple-oauth-web'
export const emailRedesignWeb = 'growth-email-redesign-web'
export const oakRedirect = 'core-oak-redirect-web'
export const removeEmailMfaExistingUsers =
  'cxp-remove-email-mfa-existing-users-web'
